import PropTypes from 'prop-types';
import { NavLink as RouterLink } from 'react-router-dom';
import { Box, List, ListItemText, Collapse } from '@mui/material';
import { StyledNavItem, StyledNavItemIcon } from './styles';
import { useSelector } from 'react-redux';
import "./NavSection.css";
import Iconify from '../iconify/Iconify';

NavSection.propTypes = {
  data: PropTypes.array,
};

export default function NavSection({ data = [], ...other }) {
  return (
    <Box {...other}>
      <List disablePadding sx={{ p: 1 }} className='nav-section-wrap'>
        {data.map((item) => (
          <NavItem key={item.title} item={item} />
        ))}
      </List>
    </Box>
  );
}

NavItem.propTypes = {
  item: PropTypes.object,
};

export function NavItem({ item }) {
  const storeSelector = useSelector((state) => state.store);
  const storeDetails = storeSelector?.details;
  const { title, path, icon, info, iconType } = item;
  return (
    <StyledNavItem
      component={RouterLink}
      to={path}
      sx={{
        '&.active': {
          color: 'text.primary',
          color: 'rgb(0, 171, 85)',
          bgcolor: 'action.selected',
          fontWeight: 'fontWeightBold',
          backgroundColor: 'rgba(0, 171, 85, 0.08)',
        },
      }}
    >
      <StyledNavItemIcon>
        {iconType ?
          <Iconify width={22} icon={icon} />
          : <>{icon && icon}</>
        }
      </StyledNavItemIcon>
      <ListItemText disableTypography primary={title} className='nav-menu-text' />
      {info && info}
    </StyledNavItem>
  );
}
